import { ClientRoutes } from "@/data/enums/router";

export default [
  {
    children: [
      {
        label: "_.my_tickets",
        to: {
          name: ClientRoutes.SUPPORT_TICKETS
        },
        children: [
          {
            label: "_.add",
            to: {
              name: ClientRoutes.SUPPORT_TICKETS_ADD
            }
          }
        ]
      }
    ]
  }
];
